/**
 * L2-P3: moved to @miq/platform-ui (components/table-paginator/table-paginator.component.ts). This shim keeps the old import
 * path working; new code should import from '@miq/platform-ui'.
 */
export { TablePaginatorComponent } from '@miq/platform-ui';
